import { defineStore } from 'pinia'
import axios from '@/utils/axios'

const CACHE_TIME = 30 * 60 * 1000 

export const useMasterDataStore = defineStore('masterData', {
  state: () => ({
    countries: [],
    currencies: [],
    standardUnits: [],
    dimensionalUnits: [],
    lastFetch: 0,
    loading: false,
  }),

  persist: {
    paths: ['countries', 'currencies', 'standardUnits', 'dimensionalUnits', 'lastFetch']
  },

  actions: {
    async loadAll(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < CACHE_TIME
      const hasData = this.countries.length && this.currencies.length

      if (!force && isFresh && hasData) return
      if (this.loading) return

      this.loading = true
      try {
        const results = await Promise.allSettled([
          axios.get('/countries'),
          axios.get('/currencies'),
          axios.get('/units?type=standard'),
          axios.get('/units?type=dimensional'),
        ])

        const [countriesRes, currenciesRes, stdRes, dimRes] = results

        if (countriesRes.status === 'fulfilled')  this.countries        = countriesRes.value.data.data
        if (currenciesRes.status === 'fulfilled') this.currencies       = currenciesRes.value.data.data
        if (stdRes.status === 'fulfilled')        this.standardUnits    = stdRes.value.data.data
        if (dimRes.status === 'fulfilled')        this.dimensionalUnits = dimRes.value.data.data

        this.lastFetch = now
      } finally {
        this.loading = false
      }
    },

    refresh() {
      return this.loadAll(true)
    },

    async refreshCountries() {
      try {
        const res = await axios.get('/countries')
        this.countries = res.data.data
      } catch (e) { console.error('countries fetch error', e) }
    },

    async refreshCurrencies() {
      try {
        const res = await axios.get('/currencies')
        this.currencies = res.data.data
      } catch (e) { console.error('currencies fetch error', e) }
    },

    async refreshUnits() {
      try {
        const [stdRes, dimRes] = await Promise.allSettled([
          axios.get('/units?type=standard'),
          axios.get('/units?type=dimensional'),
        ])
        if (stdRes.status === 'fulfilled') this.standardUnits    = stdRes.value.data.data
        if (dimRes.status === 'fulfilled') this.dimensionalUnits = dimRes.value.data.data
      } catch (e) { console.error('units fetch error', e) }
    },

    clearCache() {
      this.countries        = []
      this.currencies       = []
      this.standardUnits    = []
      this.dimensionalUnits = []
      this.lastFetch        = 0
      this.loading          = false
    }
  }
})